import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "p-2.5 bg-purple-50 rounded-xl" }
const _hoisted_5 = { class: "min-w-0" }
const _hoisted_6 = { class: "text-xs text-dashboard-muted mt-1 font-mono break-all" }
const _hoisted_7 = {
  key: 0,
  class: "bg-white border border-dashboard-border rounded-xl p-16 text-center"
}
const _hoisted_8 = {
  key: 1,
  class: "bg-red-50 border border-red-200 rounded-xl p-4 flex items-start gap-3"
}
const _hoisted_9 = { class: "text-sm text-red-600 mt-1" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "bg-white border border-dashboard-border rounded-xl shadow-sm p-4 mb-4" }
const _hoisted_12 = { class: "flex items-center gap-6 flex-wrap" }
const _hoisted_13 = { class: "text-2xl font-bold text-dashboard-text" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "text-sm font-mono text-dashboard-text" }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "text-sm text-dashboard-text" }
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { class: "text-sm text-dashboard-text capitalize" }
const _hoisted_21 = { class: "bg-white border border-dashboard-border rounded-xl shadow-sm overflow-hidden" }
const _hoisted_22 = { class: "px-4 py-3 border-b border-dashboard-border flex items-center gap-2" }
const _hoisted_23 = {
  key: 0,
  class: "p-12 text-center text-sm text-dashboard-muted italic"
}
const _hoisted_24 = {
  key: 1,
  class: "divide-y divide-dashboard-border"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "flex-1 min-w-0" }
const _hoisted_27 = { class: "flex items-center gap-2 flex-wrap" }
const _hoisted_28 = { class: "font-medium text-dashboard-text" }
const _hoisted_29 = { class: "text-xs text-dashboard-muted mt-0.5 flex items-center gap-2 flex-wrap" }

import { ref, computed, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import {
  ArrowLeft, Link2, AlertCircle, History, ChevronRight,
} from 'lucide-vue-next'
import AdminLayout from '@/layouts/AdminLayout.vue'
import AuditLogDetailPanel from '@/components/audit/AuditLogDetailPanel.vue'
import { apiFetch } from '@/utils/apiFetch'
import { useToast } from '@/utils/toast'
import {
  SEVERITY_META, SOURCE_META, getActionLabel, getDomainMeta, formatDateTime,
} from '@/utils/auditMeta'
import type { AuditLogEntry } from '@/utils/auditMeta'


export default /*@__PURE__*/_defineComponent({
  __name: 'RequestCorrelationView',
  setup(__props) {

const route = useRoute()
const toast = useToast()

const requestId = computed(() => String(route.params.uuid))
const entries = ref<AuditLogEntry[]>([])
const loading = ref(false)
const error = ref('')
const selectedLog = ref<AuditLogEntry | null>(null)

const rootEntry = computed<AuditLogEntry | null>(() => entries.value[0] || null)
const firstSource = computed(() => entries.value.find(e => e.source === 'frontend')?.source || rootEntry.value?.source || null)

async function fetchEntries() {
  loading.value = true
  error.value = ''
  try {
    const result = await apiFetch(`/api/admin/audit/request/${requestId.value}/`)
    entries.value = result.entries || []
  } catch (e: any) {
    error.value = e?.message || 'Erreur'
    toast.error('Erreur', error.value)
  } finally {
    loading.value = false
  }
}

watch(requestId, fetchEntries)
onMounted(fetchEntries)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: "/audit",
            class: "text-sm text-blue-600 hover:underline inline-flex items-center gap-1 mb-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ArrowLeft), { class: "w-4 h-4" }),
              _cache[2] || (_cache[2] = _createTextVNode(" Retour aux logs d'audit "))
            ]),
            _: 1,
            __: [2]
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(Link2), { class: "w-6 h-6 text-purple-600" })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-dashboard-text" }, "Corrélation par request_id", -1)),
              _createElementVNode("p", _hoisted_6, _toDisplayString(requestId.value), 1)
            ])
          ])
        ]),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "w-10 h-10 border-4 border-[#22282F]/30 border-t-[#22282F] rounded-full animate-spin mx-auto mb-4" }, null, -1),
              _createElementVNode("p", { class: "text-dashboard-muted" }, "Chargement…", -1)
            ])))
          : (error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_unref(AlertCircle), { class: "w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" }),
                _createElementVNode("div", null, [
                  _cache[5] || (_cache[5] = _createElementVNode("p", { class: "font-medium text-red-800" }, "Erreur", -1)),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(error.value), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", null, [
                      _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-xs text-dashboard-muted" }, "Entrées corrélées", -1)),
                      _createElementVNode("p", _hoisted_13, _toDisplayString(entries.value.length), 1)
                    ]),
                    (rootEntry.value?.user)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-xs text-dashboard-muted" }, "Initié par", -1)),
                          _createVNode(_component_router_link, {
                            to: `/audit/user/${rootEntry.value.user.id}`,
                            class: "text-sm font-medium text-blue-600 hover:underline"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(rootEntry.value.user.full_name), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]))
                      : _createCommentVNode("", true),
                    (rootEntry.value?.ip_address)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-xs text-dashboard-muted" }, "Depuis l'IP", -1)),
                          _createElementVNode("p", _hoisted_16, _toDisplayString(rootEntry.value.ip_address), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (rootEntry.value?.created_at)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-xs text-dashboard-muted" }, "Démarrée", -1)),
                          _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(formatDateTime)(rootEntry.value.created_at)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (firstSource.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-xs text-dashboard-muted" }, "Source initiale", -1)),
                          _createElementVNode("p", _hoisted_20, _toDisplayString(firstSource.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_unref(History), { class: "w-4 h-4 text-dashboard-muted" }),
                    _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "text-sm font-semibold text-dashboard-text" }, "Cascade d'événements", -1))
                  ]),
                  (entries.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Aucune entrée trouvée pour ce request_id. "))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entries.value, (entry) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: entry.id
                          }, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (selectedLog.value = entry),
                              class: _normalizeClass([
                  'w-full text-left px-4 py-3 hover:bg-dashboard-bg transition-colors flex items-start gap-3 border-l-4',
                  _unref(SEVERITY_META)[entry.severity].ring,
                ])
                            }, [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(getDomainMeta)(entry.action).icon), { class: "w-4 h-4 mt-0.5 text-dashboard-muted flex-shrink-0" })),
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                  _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(getActionLabel)(entry.action)), 1),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(['text-[10px] px-1.5 py-0.5 rounded font-medium', _unref(SOURCE_META)[entry.source].badge])
                                  }, _toDisplayString(entry.source), 3),
                                  (entry.severity !== 'info')
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: _normalizeClass(['text-[10px] px-1.5 py-0.5 rounded font-medium', _unref(SEVERITY_META)[entry.severity].badge])
                                      }, _toDisplayString(_unref(SEVERITY_META)[entry.severity].label), 3))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("span", null, _toDisplayString(_unref(formatDateTime)(entry.created_at)), 1),
                                  (entry.user)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _cache[12] || (_cache[12] = _createElementVNode("span", null, "·", -1)),
                                        _createElementVNode("span", null, _toDisplayString(entry.user.full_name), 1)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (entry.courrier_id)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _cache[13] || (_cache[13] = _createElementVNode("span", null, "·", -1)),
                                        _createVNode(_component_router_link, {
                                          to: `/audit/courrier/${entry.courrier_id}`,
                                          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                                          class: "text-blue-600 hover:underline"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Courrier #" + _toDisplayString(entry.courrier_id), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createVNode(_unref(ChevronRight), { class: "w-4 h-4 text-dashboard-muted flex-shrink-0 mt-1" })
                            ], 10, _hoisted_25)
                          ]))
                        }), 128))
                      ]))
                ])
              ]))
      ]),
      (selectedLog.value)
        ? (_openBlock(), _createBlock(AuditLogDetailPanel, {
            key: 0,
            log: selectedLog.value,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (selectedLog.value = null))
          }, null, 8, ["log"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})